import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const EyeShow: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[25px] h-[24px] stroke-[2px]', className)}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Icon=Show">
      <g id="Vector">
        <path
          d="M4.23963 13.7788C6.01907 15.5478 9.12236 17.9999 12.653 17.9999C16.1837 17.9999 19.2864 15.5478 21.0658 13.7788C21.5351 13.3123 21.7705 13.0782 21.92 12.6201C22.0266 12.2933 22.0266 11.7067 21.92 11.3799C21.7705 10.9218 21.5351 10.6877 21.0658 10.2211C19.2864 8.45208 16.1837 6 12.653 6C9.12236 6 6.01907 8.45208 4.23963 10.2211C3.76997 10.688 3.53512 10.9216 3.38563 11.3799C3.27901 11.7067 3.27901 12.2933 3.38563 12.6201C3.53512 13.0784 3.76997 13.3119 4.23963 13.7788Z"
          stroke="currentColor"
          strokeWidth="currentStrokWidth"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.6528 12C10.6528 13.1046 11.5483 14 12.6528 14C13.7574 14 14.6528 13.1046 14.6528 12C14.6528 10.8954 13.7574 10 12.6528 10C11.5483 10 10.6528 10.8954 10.6528 12Z"
          stroke="currentColor"
          strokeWidth="currentStrokWidth"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export default EyeShow;
